"use strict";
var defineWellKnownSymbol = require("../internals/well-known-symbol-define");
defineWellKnownSymbol("search");
